import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {ApolloContext} from "./Apollo_Context";
import {APOLLO_PROFILE_SYSTEM_ADMIN} from "./Apollo_Authorization";

/**
 * Tab画面パーツ
 */

export function a11yProps(index: any) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}
export interface tabsprop {
    value: any ;
    setValue: any;
    tablabel: string[];
}

export function ApolloTabs (props:tabsprop) {
    const {state} = React.useContext(ApolloContext)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        props.setValue(newValue);
    };

    return (
        <Tabs value={ props.value} onChange={handleChange} aria-label="creative tabs">
            <Tab label={ props.tablabel[0]} {...a11yProps(0)} />
            {(state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN) && 
                <Tab label={ props.tablabel[1]} {...a11yProps(1)} />
            }
        </Tabs>
    )
}
export function ApolloTabs2 (props:tabsprop) {
    const {state} = React.useContext(ApolloContext)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        props.setValue(newValue);
    };

    return (
        <Tabs value={ props.value} onChange={handleChange} aria-label="creative tabs">
            {
                props.tablabel
                    ? props.tablabel.map((value, index) => {
                        return (<Tab label={value} {...a11yProps(index)} />)
                    })
                    : undefined
            }
        </Tabs>
    )
}
export interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}
export function ApolloTabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {children}
        </div>
    );
}
